import '@babel/polyfill';
import '@codev/helix-bootstrap';
import 'url-search-params-polyfill';
import 'whatwg-fetch';
import window from './globalWrappers/window.js';
import initPasswordLoginView from './initPasswordLoginView.jsx';

window.initPasswordLoginView = initPasswordLoginView;
